import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
// import { ErrorComponent } from '../error/error.component';
import { localeEnglish } from 'app/navigation/i18n/en';
import { localeSpanish } from 'app/navigation/i18n/es';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    spanish = localeSpanish;
    english = localeEnglish;

    constructor(private dialog: MatDialog, private translator: TranslateService,
        private _fuseTranslationLoaderService: FuseTranslationLoaderService) {
        this._fuseTranslationLoaderService.loadTranslations(this.english, this.spanish);
    }

    /**
     * Itercepts every request error in order to handle a good message.
     * @param req request to be handle.
     * @param next get to the next step of the request
     */
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {

        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse) => {
                // I get the default error message and title fron the translate file.

                // Check if the request has a error object.
                // if (error.error.message) {

                //     // // I check the status code if is 401 then user or pass are not correct so i select the first error message that is for login failed.
                //     // if (error.status === 4   01) {
                //     //     // Depending on the languaje we select the message and title.
                //     //     errorMessage = 'Error you are not logged in!';
                //     // } // Otherwise i just pass the error message. 
                //     // else {
                //     //     errorMessage = error.error.message;
                //     // }
                // }

                // I open and inject data to the dialog so the dialog can show the message.
                // this.dialog.open(ErrorComponent, { data: { message: errorMessage, title: errorTitle } });
                //alert('Error:  ' + errorMessage);     
                return throwError(error);
            })
        );
    }
}
